import { NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { PositionType, TooltipDirective } from '@com-delta-omnichannel/mach';
import { BookWidgetFieldInfoModal } from '../../../models/book-widget-aem.interfaces';

@Component({
  selector: 'idp-info-tooltip',
  standalone: true,
  imports: [TooltipDirective, NgIf],
  templateUrl: './info-tooltip.component.html',
  styleUrls: ['./info-tooltip.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InfoTooltipComponent {
  @Input() infoModal!: BookWidgetFieldInfoModal;
  @Input() toolTipPosition: PositionType = 'bottom-left';
}
